import { isLocalUrl, openNewTab } from '../helpers/helpers';

export default function customTicketButton() {
  const widgetName = 'customTicketButton';
  const widgetOpts = customTicketButtonOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomTicketBtn(data);
      } else {
        $widget.remove();
      }
    },
  });

  function createCustomTicketBtn(widgetData) {
    const { Title, URL } = widgetData.items[0];

    if (URL == null) {
      $widget.remove();
      $('body').addClass(`${widgetName}-no-data`);
    } else {
      const isLocal = isLocalUrl(URL);
      const targetElement = openNewTab(isLocal);
      $widget.find('.card-widget-item').replaceWith(
        `
        <a tabindex="0" href="${URL}" ${targetElement} class="tkt-wrapper">
          <div class="ticket-shape">
          <span class="ticket-shappe-img shape-1"></span>
          <span class="ticket-shappe-img shape-2"></span>
          </div>
          <span class="ticket-btn">${Title}</span>
        </a>

          `,
      );
    }
  }
}
